export const workExperience = [
    {
        name: "Frontend Engineer Intern, TikTok",
        period: "Jan 2023 - Nov 2023",
        department: "Global E-Commerce (Commercial Platform)",
        jobscope: [
            "Implemented Data Overview, Live Diagnosis, and Shopping Center Analytics features in the TikTok Shop Seller  Center Data Compass App using React, Typescript, and Rematch, resulting in a 40% increase in user retention rate through enhanced cross-platform compatibility.",
            "Developed and integrated internationalization and localization SDK toolsets across the TikTok Shop Seller Center Data Compass PC and App modules, establishing standardized date, time, and number formats",
            "Improved project workflow operations by resolving numerous bugs, errors, and security risks, leading to enhanced code efficiency and reduced package deprecation warnings"
        ],
        logo: 'assets/tiktok.png'
    },
    {
        name: "Software Developer Intern, Singtel",
        period: "May 2022 - Aug 2022",
        department: "Group Enterprise 5G/IOT Product House",
        jobscope: [
            "Designed and developed a full-stack Credential Management Platform for Group Enterprise 5G/IOT Product House, utilizing Vue.js, Spring Boot, and MongoDB. Responsibilities included interface design, API endpoint development, unit test case creation with JUnit, and database schema design",
            "Utilize hashing and encryption methods, including symmetric AES and asymmetric encryption, to enhance the security of credential data transmission, mitigating the risk of eavesdropping attacks "],
        logo: 'assets/singtel.png'
    },

]